import React, { useEffect, useState } from "react";
import {
  Container,
  Accordion,
  ListGroup,
  Button,
  Spinner,
  Form,
} from "react-bootstrap";
import { getFirestore, collection, getDocs } from "firebase/firestore";


function Dashboard() {
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [criterioBusqueda, setCriterioBusqueda] = useState("ticket");
  const [valorBusqueda, setValorBusqueda] = useState("");
  const [resultadoBusqueda, setResultadoBusqueda] = useState(null);
  const [dinamicas, setDinamicas] = useState([]);
  const [dinamicaSeleccionada, setDinamicaSeleccionada] = useState("");
  const [infoUsuario] = useState(null);
  const [busquedaRealizada, setBusquedaRealizada] = useState(false);

  useEffect(() => {
    const obtenerDinamicas = async () => {
      const db = getFirestore();
      const sorteosRef = collection(db, "sorteos");
      try {
        const sorteosSnapshot = await getDocs(sorteosRef);
        const todasLasDinamicas = sorteosSnapshot.docs.map((doc) => ({
          id: doc.id,
          titulo: doc.data().title || "Sorteo sin título",
        }));
        setDinamicas(todasLasDinamicas);
      } catch (error) {
        console.error("❌ Error al obtener las dinámicas:", error);
      }
    };
    obtenerDinamicas();
  }, []);

  useEffect(() => {
    const obtenerUsuarios = async () => {
      setLoading(true);
      const db = getFirestore();
      const sorteosRef = collection(db, "sorteos");
      try {
        const sorteosSnapshot = await getDocs(sorteosRef);
        if (sorteosSnapshot.empty) {
          setUsuarios([]);
          setLoading(false);
          return;
        }

        const usuariosSet = new Map();

        await Promise.all(
          sorteosSnapshot.docs.map(async (sorteoDoc) => {
            const sorteoId = sorteoDoc.id;
            const sorteoData = sorteoDoc.data();
            const sorteoTitulo = sorteoData?.title || "Sorteo sin título";

            const ticketsRef = collection(db, "sorteos", sorteoId, "tickets");
            const ticketsSnapshot = await getDocs(ticketsRef);

            ticketsSnapshot.forEach((ticketDoc) => {
              const data = ticketDoc.data();
              if (data.usuario) {
                const usuarioExistente = usuariosSet.get(data.usuario);

                if (usuarioExistente) {
                  if (!usuarioExistente.sorteos[sorteoTitulo]) {
                    usuarioExistente.sorteos[sorteoTitulo] = [];
                  }
                  usuarioExistente.sorteos[sorteoTitulo].push(data.numero);
                } else {
                  usuariosSet.set(data.usuario, {
                    id: data.usuario,
                    correo: data.usuario,
                    telefono: data.telefono || "No disponible",
                    instagram: data.instagram || "No disponible",
                    sorteos: {
                      [sorteoTitulo]: [data.numero],
                    },
                  });
                }
              }
            });
          })
        );

        setUsuarios(Array.from(usuariosSet.values()));
      } catch (error) {
        console.error("Error al obtener usuarios:", error);
      } finally {
        setLoading(false);
      }
    };
    obtenerUsuarios();
  }, []);

  const buscar = () => {
    if (!valorBusqueda.trim()) {
      setResultadoBusqueda(null);
      return;
    }

    const dinamica = dinamicas.find((d) => d.id === dinamicaSeleccionada);
    if (!dinamica) {
      console.error("⚠️ No se encontró la dinámica seleccionada.");
      return;
    }

    const dinamicaTitulo = dinamica.titulo;

    let encontrado = null;

    usuarios.forEach((usuario) => {
      if (!usuario.sorteos || typeof usuario.sorteos !== "object") {
        return;
      }

      const ticketsDinamica = usuario.sorteos[dinamicaTitulo] || [];

      if (
        criterioBusqueda === "correo" &&
        usuario.correo === valorBusqueda.trim()
      ) {
        encontrado = {
          usuario: usuario.correo,
          telefono: usuario.telefono || "No disponible",
          instagram: usuario.instagram || "No disponible",
          tickets:
            ticketsDinamica.length > 0
              ? ticketsDinamica
              : "Sin tickets en esta dinámica",
        };
      }

      if (criterioBusqueda === "ticket") {
        const numeroBuscado = Number(valorBusqueda);

        const ticketsNumericos = ticketsDinamica.map((ticket) =>
          Number(ticket)
        );

        if (ticketsNumericos.includes(numeroBuscado)) {
          encontrado = {
            usuario: usuario.correo,
            telefono: usuario.telefono || "No disponible",
            instagram: usuario.instagram || "No disponible",
            tickets: ticketsDinamica,
          };
        }
      }
    });
    setBusquedaRealizada(true);
    setResultadoBusqueda(encontrado);
  };

  return (
    <div>
      <Container className="mt-5">
        <h3>Historial de compras</h3>
        <Form.Group controlId="seleccionarDinamica" className="mt-3">
          <Form.Label>
            <strong>Seleccionar dinámica:</strong>
          </Form.Label>
          <Form.Select
            value={dinamicaSeleccionada}
            onChange={(e) => setDinamicaSeleccionada(e.target.value)}
          >
            <option value="">Todas las dinámicas</option>
            {dinamicas.map((dinamica) => (
              <option key={dinamica.id} value={dinamica.id}>
                {dinamica.titulo}
              </option>
            ))}
          </Form.Select>
        </Form.Group>

        {/* 🔎 Buscador */}
        <Form className="mt-4">
          <Form.Group>
            <Form.Label>
              <strong>Buscar por:</strong>
            </Form.Label>
            <Form.Select
              value={criterioBusqueda}
              onChange={(e) => setCriterioBusqueda(e.target.value)}
            >
              <option value="ticket">Número de Ticket</option>
              <option value="correo">Correo Electrónico</option>
            </Form.Select>
          </Form.Group>

          <Form.Group controlId="buscarTicket" className="mt-2">
            <Form.Label>
              <strong>
                Ingresar{" "}
                {criterioBusqueda === "ticket" ? "número de ticket" : "correo"}
              </strong>
            </Form.Label>
            <div className="d-flex">
              <Form.Control
                type="text"
                placeholder={
                  criterioBusqueda === "ticket"
                    ? "Ejemplo: 12345"
                    : "Ejemplo: usuario@email.com"
                }
                value={valorBusqueda}
                onChange={(e) => setValorBusqueda(e.target.value)}
              />
              <Button variant="primary" className="ms-2" onClick={buscar}>
                Buscar
              </Button>
            </div>
          </Form.Group>
        </Form>

        {/* 🔎 Resultado de la búsqueda */}
        {busquedaRealizada && !(resultadoBusqueda || infoUsuario) ? (
          <div className="mt-3 p-3 border rounded bg-light text-center">
            <h5>⚠️ No se encontraron resultados</h5>
          </div>
        ) : (
          (resultadoBusqueda || infoUsuario) && (
            <div className="mt-3 p-3 border rounded bg-light">
              <h5>📌 Información del usuario:</h5>
              <p>
                <strong>Usuario:</strong>{" "}
                {resultadoBusqueda?.usuario || infoUsuario?.usuario}
              </p>
              <p>
                <strong>Teléfono:</strong>{" "}
                {resultadoBusqueda?.telefono || infoUsuario?.telefono}
              </p>
              <p>
                <strong>Instagram:</strong>{" "}
                {resultadoBusqueda?.instagram || infoUsuario?.instagram}
              </p>
              <p>
                <strong>Tickets:</strong>{" "}
                {(resultadoBusqueda?.tickets || infoUsuario?.tickets)?.join(
                  " - "
                ) || "Sin tickets"}
              </p>
            </div>
          )
        )}
      </Container>

      {/* 🔹 Lista de usuarios y sus tickets */}
      <Container className="mt-3">
        <Accordion>
          {loading ? (
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Cargando...</span>
            </Spinner>
          ) : usuarios.length > 0 ? (
            usuarios.map((usuario, index) => (
              <Accordion.Item eventKey={index.toString()} key={usuario.id}>
                <Accordion.Header>{usuario.correo}</Accordion.Header>
                <Accordion.Body>
                  <ListGroup>
                    <ListGroup.Item>
                      📧 <strong>Correo:</strong> {usuario.correo}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      📞 <strong>Teléfono:</strong> {usuario.telefono}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      📸 <strong>Instagram:</strong> {usuario.instagram}
                    </ListGroup.Item>
                    <ListGroup.Item>
                      <strong>Tickets por sorteo:</strong>
                      <ul>
                        {Object.entries(usuario.sorteos).map(
                          ([titulo, tickets]) => (
                            <li key={titulo}>
                              <strong>{titulo}:</strong> {tickets.join(" - ")}
                            </li>
                          )
                        )}
                      </ul>
                    </ListGroup.Item>
                  </ListGroup>
                </Accordion.Body>
              </Accordion.Item>
            ))
          ) : (
            <p>No hay usuarios con boletos comprados.</p>
          )}
        </Accordion>
      </Container>
    </div>
  );
}

export default Dashboard;
